/* 🌳 Houtwijzer-lade: openen/sluiten (native <dialog>), live zoeken, zwevende knop op gsm. */
(function () {
  var lade = document.querySelector('.ew-hw-lade');
  if (!lade || typeof lade.showModal !== 'function') return;
  var zoek = lade.querySelector('[data-ew-hw-zoek]');
  var leeg = lade.querySelector('[data-ew-hw-leeg]');
  var rubs = Array.prototype.slice.call(lade.querySelectorAll('[data-ew-hw-rub]'));
  var hier = lade.querySelector('.is-hier');

  function open(metZoek) {
    lade.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (metZoek && zoek) zoek.focus();
    else if (hier) hier.scrollIntoView({ block: 'center' });
  }
  function dicht() { lade.close(); }
  lade.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
  // klik op de achtergrond (buiten de lade) sluit
  lade.addEventListener('click', function (e) {
    var r = lade.getBoundingClientRect();
    if (e.target === lade && (e.clientX > r.right || e.clientX < r.left || e.clientY < r.top || e.clientY > r.bottom)) dicht();
  });
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-ew-hw-open]');
    if (k) { e.preventDefault(); open(k.getAttribute('data-ew-hw-open') === 'zoek'); }
    if (e.target.closest('[data-ew-hw-sluit]')) dicht();
  });

  // Live zoeken: niet-treffers verbergen, rubrieken met treffers openklappen.
  var norm = function (s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var open0 = rubs.map(function (d) { return d.open; });
  if (zoek) zoek.addEventListener('input', function () {
    var q = norm(zoek.value.trim()), totaal = 0;
    rubs.forEach(function (d, i) {
      var n = 0;
      d.querySelectorAll('.ew-hw-groep').forEach(function (g) {
        var gn = 0;
        g.querySelectorAll('li').forEach(function (li) {
          var t = !q || norm(li.textContent).indexOf(q) > -1;
          li.toggleAttribute('data-ew-hw-uit', !t);
          if (t) gn++;
        });
        g.toggleAttribute('data-ew-hw-uit', !gn);
        n += gn;
      });
      d.toggleAttribute('data-ew-hw-uit', !n);
      d.open = q ? n > 0 : open0[i];
      totaal += n;
    });
    if (leeg) leeg.hidden = totaal > 0;
  });

  // Zwevende inhoudsknop op gsm: altijd zichtbaar (vindbaarheid gaat voor), desktop heeft de vaste linkertab.
  var zweef = document.querySelector('.ew-hw-zweef');
  if (zweef) zweef.hidden = false;
})();
